/** NG判定後に次の処理を実行するまでの待ち時間 */
export const NG_DELAY = 700;
/** マーカーの数 */
export const NUMBER_OF_MAKER = 5;
/** マーカーの半径 */
export const RADIUS_OF_MAKER = 15;
/** 水没気密検査の画像のセクションID */
export const WET_LEAK_TEST_SECTION = {
  OSA1: 4,
  OSA2: 22,
  OSA3: 27,
  FSA: 33,
  DTA: 41,
  FSB: 50,
  Connector: 56,
};
/** 画像表示に使用する属性 */
export const MODEL_ATTRIBUTES = {
  /** EUS */
  EUS: 21,
  /** 十二指腸 */
  DUODENUM: 4,
  /** 2ch/大鉗子 */
  LARGE_FORCEPS_2CH: 20,
  /** スリム */
  SLIM: 52,
  /** G7スリム */
  G7_SLIM: 53,
  /** EBUS */
  EBUS: 31,
  /** 2-Way */
  TWO_WAY: 56,
};
/** 気密検査のID */
export const LEAK_TEST = {
  categoryId: '1',
  typeId: '1-1',
  dryLeakTestItemId: '1-1-2',
  wetLeakTestItemId: '1-1-3',
};
/** 気密検査 -> 浸水確認のID */
export const CONFIRMED_FLOODING_TEST = {
  categoryId: '1',
  typeId: '1-2',
  lgConnectorId: '1-2-3',
};
/** FSB/コネクタ/VCA/導通 -> LGコネクター -> 水滴のID */
export const LG_CONNECTOR_TEST = {
  categoryId: '5',
  typeId: '5-1',
  itemId: '5-1-12',
};
/** FSB/コネクタ/VCA/導通 -> LG棒 -> 水滴のID */
export const LPA_TEST = {
  categoryId: '5',
  typeId: '5-2',
  itemId: '5-2-12',
};
/** 先端部の画像を使用する中項目 */
export const DTA_IMAGE_INSPECTION = {
  categoryId: '4',
  typeIdList: ['4-1', '4-2', '4-3', '4-4'],
};
/** 硬度可変測定の検査ID */
export const VARIABLE_HARDNESS = {
  categoryId: '6',
  typeId: '6-7',
  itemId: '6-7-13',
};
/** 各マーカーの初期X座標の基準値 */
export const INITIAL_X_POSITION = 50 / NUMBER_OF_MAKER;
/** 各マーカーの初期Y座標（固定値） */
export const INITIAL_Y_POSITION = -60;
/** マーカー間のスペース */
export const MARKER_SPACING = 280 / NUMBER_OF_MAKER;
/** 表示する判定結果のラベル(言語に依存しない) */
export const JUDGEMENT_LABEL: { [key: number]: string } = {
  0: '',
  1: 'OK',
  2: 'NG',
  3: 'N/A',
};
/** 診断結果 */
export const JUDGEMENT = {
  /** 空(未選択) */
  EMPTY: 0,
  /** OK */
  OK: 1,
  /** NG */
  NG: 2,
  /** N/A */
  NA: 3,
};
/** 小項目(階層0)の入力方法 */
export const INPUT_TYPE = {
  /** チェックボックス */
  CHECKBOX: 0,
  /** 数値 */
  NUMBER: 1,
};
/** 数値入力の項目の整数部最大桁数 */
export const INTEGER_MAX_DIGITS = 5;
/** 数値入力の項目の小数部最大桁数 */
export const DECIMAL_MAX_DIGITS = 2;
/** 表示するパーツリスト画面のURL */
export const PARTS_LIST_BASE_URL =
  'https://aesop-jp-partslist-test-webapp01.azurewebsites.net/assets/isometrics/';
/** 診断画像の格納先(ストレージアカウントコンテナ名) */
export const DIAGNOSTIC_CONTAINER_NAME = 'diagnostic';
/** NGサンプルの格納先(ストレージアカウントコンテナ名) */
export const NG_SAMPLE_CONTAINER_NAME = 'ngsample';
/** マニュアルの格納先(ストレージアカウントコンテナ名) */
export const MANUAL_CONTAINER_NAME = 'manual';
/** InspeX上での修理番号に紐づくステータス */
export const INSPECTION_STATUSES = {
  /** 受入診断シリアルチェック中 */
  INSPECTION_SERIAL_CHECK: 110,
  /** 受入診断中 */
  INSPECTION_IN_PROGRESS: 120,
  /** 受入診断結果確認 */
  INSPECTION_INPUT_RESULT: 130,
  /** 受入確定診断中 */
  INSPECTION_CONFIRM: 140,
  /** パーツ選択中 */
  INSPECTION_PARTS_SELECT: 150,
  /** 受入診断のデータ未連携 */
  INSPECTION_NOT_LINKED: 160,
  /** No Fault Found */
  NO_FAULT_FOUND: 170,
  /** 受入診断完了 */
  INSPECTION_COMPLETE: 180,
  /** 出荷検査中 */
  QC_IN_PROGRESS: 210,
  /** 出荷検査確定診断 */
  QC_CONFIRM: 220,
  /** 再修理中 */
  QC_REPAIRING: 230,
  /** 出荷検査のデータ未連携 */
  QC_NOT_LINKED: 240,
  /** 出荷検査完了 */
  QC_COMPLETE: 250,
} as const;
/** テンプレート区分 */
export const TEMPLATE_CLASS = {
  /** 通常診断 */
  FULL: 1,
  /** 簡易診断 */
  SIMPLE: 2,
} as const;

/** 連携するデータの種類 */
export const SEND_EXFM_TYPE = {
  /** 受入診断 */
  INSPECTION: 0,
  /** 出荷検査 */
  QC: 1,
} as const;
/** 履歴のステータス */
export const HISTORY_STATUSES = {
  /** なし */
  NONE: { id: 0, key: '-' },
  /** 受入診断 */
  INSPECTION: { id: 1, key: 'LBL_HISTORY_INSPECTION' },
  /** 確定診断 */
  INSPECTION_CONFIRM: { id: 2, key: 'LBL_HISTORY_CONFIRM' },
  /** パーツ選択 */
  PARTS_SELECTION: { id: 3, key: 'LBL_HISTORY_PARTS_SELECTION' },
  /** 出荷検査 */
  QC: { id: 4, key: 'LBL_HISTORY_QC' },
} as const;
/** 履歴のタイプ */
export const HISTORY_TYPE = {
  /** 保存 */
  SAVE: { id: 0, key: 'LBL_HISTORY_SAVE' },
  /** 完了 */
  COMPLETION: { id: 1, key: 'LBL_HISTORY_COMPLETION' },
  /** 作成 */
  CREATE: { id: 2, key: 'LBL_HISTORY_CREATE' },
  /** 削除 */
  DELETE: { id: 3, key: 'LBL_HISTORY_DELETE' },
} as const;
/** 画像アップロードの拡張子*/
export const ACCEPT_TYPE_IMAGE = 'image/jpeg, image/png, image/bmp, image/gif';
/** ファイルアップロード時の分割サイズ(10MB) */
export const CHUNK_SIZE = 1024 * 1024 * 10;
/** 帳票に表示する先端部画像のサイズ(テーブルの行数で計算) */
export const DTA_IMAGE_SIZE = 15;
/** 存在しない結果を表す文字 */
export const NOT_EXIST_RESULT_TEXT = '-';
/** パーツ属性 */
export const PARTS_ATTRIBUTE = {
  MUST: 'M',
  WANT: 'W',
  PACKING: 'P',
  SCREW: 'S',
};

/** オプションパーツ属性 */
export const OPTION_PARTS_ATTRIBUTES = [
  PARTS_ATTRIBUTE.PACKING,
  PARTS_ATTRIBUTE.SCREW,
];

/** パーツ選択画面の発注量の下限値 */
export const MIN_PARTS_AMOUNT = 1;
